<template>
  <div class="row">
    <div class="col_12">
        <div class="card no_border home_table">
            <div class="card-body">
                <div class="d_flex_btwn title">
                  <h2>{{ $t('lectureVideo') }}</h2>
                  <router-link :to="{ name: 'lecture_video_add'}" class="add_new cursor_pointer">+ {{ $t('createLectureVideo') }}</router-link>
                </div>
                <div class="row">
                  <div class="col_4">
                    <div class="d_flex_btwn title">
                      <div class="display_inline">
                        <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                      </div>
                      <div class="display_inline">
                          <button class="btn btn_success toggle_item_search search_btn" @click="queryParams.page = 1 ; searchVideo()">{{ $t('common.search') }}</button>
                          <button class="btn btn_secondary reset_btn" @click="resetAll()">{{ $t('common.reset') }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="col_3">
                    <div class="d_flex_btwn title">
                      <div class="display_inline  width_100p">
                        <span>{{ $t('sidebar.subjects.subjects') }}</span>
                      </div>
                      <select class="form_global mr_10 width_200p" v-model="filter.subject" @change="queryParams.page = 1 ; changeRoute()">
                          <option value="" selected>{{ $t('common.all') }}</option>
                          <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col_3">
                    <div class="d_flex_btwn title">
                      <div class="display_inline  width_100p">
                        <span>{{ $t('sidebar.areas.areas') }}</span>
                      </div>
                      <select class="form_global mr_10 width_200p" v-model="filter.area" @change="queryParams.page = 1 ; changeRoute()">
                          <option value="" selected>{{ $t('common.all') }}</option>
                          <option :value="area.id" v-for="area in areas" :key="'area '+area.id">{{ area.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col_2">
                    <div class="d_flex_btwn title">
                      <div class="d_flex_inline">
                        <select class="form_global width_200p" v-model="filter.per_page" @change=" queryParams.page = 1; changeRoute()">
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <table-component 
                    :columns="columns"
                    :rows="lectures"
                    :pagination="pagination"
                    @sorting="sorting"
                    :sortable="sortable"
                    @pageChanged="pageChanged">
                    <template #action="{ row }">
                        <router-link :to="{name: 'lecture_video_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_sm btn_info mr_5">
                            <i class="far fa-edit"></i>
                        </router-link>
                        <button class="btn btn_sm btn_danger" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                            <i class="far fa-trash-alt"></i>
                        </button>
                    </template>
                </table-component>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";

export default {
  components: {TableComponent},
  data() {
    return {
      lectures: [],
      subjects: [],
      areas: [],
      filter: {
        subject: '',
        area: '',
        per_page: 20
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'unit_name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },

      columns: [
        {
          label: this.$t('sidebar.lectureCommon.video_code'),
          field: "video_code",
          sortable: false
        },
        {
          label: this.$t('video_name'),
          field: "video_name",
          sortable: false
        },
        {
          label: this.$t('category'),
          field: "category.name",
          sortable: false
        },
        {
          label: this.$t('common.subject'),
          field: "subject.name",
          sortable: true
        },
        {
          label: this.$t('common.area'),
          field: "area.name",
          sortable: true
        },
        {
          label: this.$t('common.grade'),
          field: "grade.name",
          sortable: false
        },
        {
          label: this.$t('common.semester'),
          field: "semester.name",
          sortable: false
        },
        {
          label: this.$t('sidebar.lectureCommon.duration'),
          field: "duration",
          sortable: false
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
    }
  },
  watch: {
    $route(to, from) {
        if(to.name == from.name && !window._.isEqual(to, from)){
          this.setQueryData(this.getAllQueryParams())
          this.loadData()
        }
      },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }

    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
    this.axios.get('/areas').then((response) => this.areas = response.data.data);

    this.loadData();
  },
  methods: {
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        subject: query.subject,
        area: query.area,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    resetAll(){
      this.sortable = {
          order: 'created_at',
          sort: 'desc'
      }
      this.filter = {
          subject: '',
          area: '',
          per_page: 20
      }

      this.queryParams = {
          page: 1,
          search: '',
          search_columns: 'unit_name',
          sort: 'created_at',
          sort_order: 'desc',
          per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    searchVideo(){
        this.changeRoute();
    },
    sorting({column, order}) {
        this.queryParams.sort = column;
        this.queryParams.sort_order = order;
        this.queryParams.page = 1;
        this.changeRoute()
    },
    pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/lectures', {
            params: {...this.queryParams, ...this.filter}
        }).then((response) => {
            this.lectures = response.data.data;
            this.pagination = response.data.meta;
        })
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/lectures/'+row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            )
          });
        }
      });
    },
  }
}
</script>

<style scoped>
  .search_btn{
    padding: 10px 10px 10px 15px;
    margin: 0px 10px 0px 0px;
  }

  .reset_btn{
    padding: 10px 10px 10px 15px;
  }
</style>